import { memo } from "react";
import { FONT } from "../theme/tokens";
import { v } from "../utils/helpers";

const ChatBubble = memo(({ open, onClick, hasAiInstances }) => {
  if (!hasAiInstances) return null;
  return (
    <button
      onClick={onClick}
      aria-label={open ? "Chat schließen" : "AI Chat öffnen"}
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 1100,
        width: 52,
        height: 52,
        borderRadius: 16,
        border: "none",
        background: `linear-gradient(135deg, var(--accent) 0%, #818cf8 100%)`,
        color: "#fff",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: open
          ? "0 4px 24px rgba(99,102,241,.5), 0 0 0 3px rgba(99,102,241,.15)"
          : "0 4px 20px rgba(99,102,241,.35)",
        transition: "all 0.2s ease",
        transform: open ? "rotate(0deg)" : "rotate(0deg)",
        fontFamily: FONT,
      }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = "scale(1.08)";
        e.currentTarget.style.boxShadow = "0 6px 28px rgba(99,102,241,.5)";
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = open
          ? "0 4px 24px rgba(99,102,241,.5), 0 0 0 3px rgba(99,102,241,.15)"
          : "0 4px 20px rgba(99,102,241,.35)";
      }}
    >
      {open ? (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      ) : (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
        </svg>
      )}
    </button>
  );
});

export default ChatBubble;
